module.exports = __webpack_public_path__ + "static/media/ShowTeacher.078429e7.png";